import { render, staticRenderFns } from "./SdkSearch.vue?vue&type=template&id=f8b5582a&"
import script from "./SdkSearch.vue?vue&type=script&lang=js&"
export * from "./SdkSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports